import { animateValue } from './js/index.mjs';

function createInstantAnimation({ keyframes, delay: delayBy, onUpdate, onComplete, }) {
    const setValue = () => {
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        return {
            stop: () => { },
            currentTime: 0,
        };
    };
    return delayBy
        ? animateValue({
            keyframes: [0, 1],
            duration: delayBy,
            onComplete: setValue,
        })
        : setValue();
}

export { createInstantAnimation };
